import { render } from "./AppHeader.vue?vue&type=template&id=72255c8b"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
script.render = render

export default script